import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "as", "src", "background", "altText", "gatsbyImageProps", "children", "loadStrategy", "style", "imgStyle"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Image as SemanticUIImage } from 'semantic-ui-react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { BgImage } from 'gbimage-bridge';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { EAGER_LOAD_STRATEGY, IMAGE_LOAD_STRATEGIES, LAZY_LOAD_STRATEGY } from './Image.constants';
import { getGatsbyImageStyle } from './Image.utils';
import ImageOld from './components/ImageOld';
import { ChildrenPropType, ImagePropType, StylePropType } from '../../services/proptypes';
import { classNames } from '../../utils/classname';
import { isGatsbyImage, isOldGatsbyImage } from '../../utils/gatsby';
import './Image.less';
var defaultProps = {
  className: '',
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null,
  style: {},
  imgStyle: {},
  loadStrategy: LAZY_LOAD_STRATEGY
};
export default function Image(_ref) {
  var _classNames;
  var className = _ref.className,
    as = _ref.as,
    src = _ref.src,
    background = _ref.background,
    altText = _ref.altText,
    gatsbyImageProps = _ref.gatsbyImageProps,
    children = _ref.children,
    loadStrategy = _ref.loadStrategy,
    style = _ref.style,
    imgStyle = _ref.imgStyle,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var allStyles = _objectSpread(_objectSpread({}, style || {}), imgStyle || {});
  var finalClassName = classNames((_classNames = {
    image: true
  }, _defineProperty(_classNames, className, true), _defineProperty(_classNames, "background", background), _classNames));
  if (_isEmpty(src) && !_isEmpty(children)) {
    finalClassName = classNames(_defineProperty({
      'no-image': true
    }, finalClassName, true));
    return (/*#__PURE__*/
      // eslint-disable-next-line react/jsx-props-no-spreading
      React.createElement("div", _extends({}, extraProps, {
        className: finalClassName,
        style: allStyles
      }), children)
    );
  }
  if (_isEmpty(src)) {
    return null;
  }
  var isEager = loadStrategy === EAGER_LOAD_STRATEGY;
  if (isOldGatsbyImage(src)) {
    return /*#__PURE__*/React.createElement(ImageOld, _objectSpread({
      className: finalClassName,
      as: as,
      src: src,
      background: background,
      altText: altText,
      gatsbyImageProps: gatsbyImageProps,
      children: children,
      loadStrategy: loadStrategy,
      style: style,
      imgStyle: imgStyle
    }, extraProps));
  }
  if (isGatsbyImage(src)) {
    var image = getImage(src);
    var finalAltText = altText || _get(src, 'altText') || '';
    var allGatsbyImageProps = _objectSpread(_objectSpread(_objectSpread({}, extraProps), gatsbyImageProps), {}, {
      image: image,
      alt: finalAltText,
      className: finalClassName
    });
    if (background) {
      return /*#__PURE__*/React.createElement(BgImage, _extends({}, allGatsbyImageProps, {
        image: image,
        Tag: as,
        critical: isEager,
        style: allStyles
      }), children);
    }
    var _getGatsbyImageStyle = getGatsbyImageStyle(allStyles),
      parentStyles = _getGatsbyImageStyle.parentStyles,
      childStyles = _getGatsbyImageStyle.childStyles;
    return /*#__PURE__*/React.createElement(GatsbyImage, _extends({}, allGatsbyImageProps, {
      loading: loadStrategy,
      style: parentStyles,
      imgStyle: childStyles
    }));
  }

  // Handle simple URL image
  if (background) {
    return /*#__PURE__*/React.createElement(as, _objectSpread(_objectSpread({}, extraProps), {}, {
      style: _objectSpread({
        backgroundImage: "url('".concat(src, "')"),
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }, allStyles),
      alt: altText || '',
      className: finalClassName,
      loading: loadStrategy
    }), children);
  }
  return /*#__PURE__*/React.createElement(SemanticUIImage, _extends({}, extraProps, {
    loading: loadStrategy,
    src: src,
    alt: altText,
    className: finalClassName,
    style: allStyles
  }));
}
Image.defaultProps = defaultProps;